import { render } from "./IncidentFileInput.vue?vue&type=template&id=4c117fd4"
import script from "./IncidentFileInput.vue?vue&type=script&lang=js"
export * from "./IncidentFileInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__